import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'FormField';

const FormFieldApi: any = baseApi(endpoint);

export default FormFieldApi;